import {
  ContactSection,
  ServicesListSection,
  TopSection,
} from "../../components";
import FAQSection from "../../components/FAQSection/FAQSection";
import SEOHead from "../../components/SEO/SEOHead";
import {
  generateOrganizationSchema,
  generateWebPageSchema,
  generateFAQSchema,
} from "../../utils/structuredData";

const SERVICES = [
  "Home Repairs",
  "Painting",
  "Drywall Installation and Repair",
  "Plumbing & Pipes",
  "Carpentry",
  "Furniture Repairs",
];

const HomePage = () => {
  const organizationSchema = generateOrganizationSchema();
  const webPageSchema = generateWebPageSchema(
    "Brin's Handyman Services - Professional Home Repairs in Ottawa",
    "Your trusted source for professional handyman services in Ottawa and surrounding areas. We offer home repairs, painting, plumbing, carpentry, drywall, and furniture repairs. For specialized work requiring licensed professionals, we collaborate with certified contractors.",
    "https://brinshandymanservices.ca"
  );

  const faqs = [
    {
      question: "What areas do you serve?",
      answer:
        "We serve Ottawa and all surrounding areas including Kanata, Nepean, Orleans, Barrhaven, and other nearby communities.",
    },
    {
      question: "Are you licensed and insured?",
      answer:
        "Yes, we are fully licensed and insured for general handyman services. For specialized work requiring licensed professionals (such as electrical, major plumbing, gas work, or HVAC), we collaborate with certified contractors who are properly licensed and insured for those specific trades.",
    },
    {
      question: "Do you provide free estimates?",
      answer:
        "Absolutely! We provide free, no-obligation estimates for all our services.",
    },
  ];
  const faqSchema = generateFAQSchema(faqs);

  return (
    <div>
      <SEOHead
        title="Brin's Handyman Services - Professional Home Repairs in Ottawa"
        description="Your trusted source for professional handyman services in Ottawa and surrounding areas. We offer home repairs, painting, plumbing, carpentry, drywall, and furniture repairs. For specialized work requiring licensed professionals, we collaborate with certified contractors."
        canonical="/"
        structuredData={[organizationSchema, webPageSchema, faqSchema]}
      />
      <TopSection
        subTitle="WELCOME TO"
        mainTitle="Brin's Handyman Services"
        content="Your Trusted Source for Professional Handyman Services in
                  Ottawa and Surrounding Areas Are you in need of reliable,
                  skilled, and affordable handyman services in Ottawa and its
                  neighboring areas? Look no further than Brin's Handyman
                  Services!"
      />
      <ServicesListSection services={SERVICES} />
      <FAQSection />
      <ContactSection />
    </div>
  );
};

export default HomePage;
